import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../../foundation/altzero_base/base/components/ui/select';
import type { WorkflowStep } from '../../lib/billWorkflow';
import { ASSIGNED_LABELS, ASSIGNED_ORDER } from '../../lib/billRunStatus';

// Bill Runs' own copy of the "Set status…" select, with the Bill Runs labels
// (Query Retailer, Customer Response Required). It saves through the same
// billService.setWorkflowStep as the current pages; only the wording differs.

const CLEAR = '__clear__';

type AssignedStatusSelectProps = {
  testId: string;
  /** The current step, for a per-row picker; omit for the bulk "Set status…". */
  value?: WorkflowStep | null;
  disabled?: boolean;
  onSet: (step: WorkflowStep | null) => void;
  compact?: boolean;
};

export const AssignedStatusSelect = ({ testId, value, disabled, onSet, compact }: AssignedStatusSelectProps) => (
  <Select
    value={value ?? ''}
    disabled={disabled}
    onValueChange={(v) => onSet(v === CLEAR ? null : (v as WorkflowStep))}
  >
    <SelectTrigger
      data-testid={testId}
      aria-label={value === undefined ? 'Set assigned status for selected bills' : 'Assigned status'}
      className={compact ? 'h-7 w-40 text-xs bg-white' : 'h-8 w-48 text-xs bg-white'}
    >
      <SelectValue placeholder={value === undefined ? 'Set assigned status…' : '—'} />
    </SelectTrigger>
    <SelectContent>
      {ASSIGNED_ORDER.map((step) => (
        <SelectItem key={step} value={step} className="text-xs">{ASSIGNED_LABELS[step]}</SelectItem>
      ))}
      <SelectItem value={CLEAR} className="text-xs">Clear assigned status</SelectItem>
    </SelectContent>
  </Select>
);
